import { isAnyArray } from 'is-any-array';
/**
 * Recursively extracts all JSON paths with their corresponding primitive values from an object.
 * @param obj - The input object or value to traverse.
 * @param options - Optional parameters to control traversal and filtering.
 * @returns an array of objects each containing a jpath and its corresponding primitive value.
 */
export function getJPaths(obj, options = {}) {
    const { maxArrayElements = 5, maxDepth = 3, includeJPaths = [], excludeJPaths = [], includeJPathRegexps = [], excludeJPathRegexps = [], modifiers = {}, } = options;
    // convert modifiers to a Map for faster access
    const modifiersMap = new Map(Object.entries(modifiers));
    function matchesInclude(path) {
        if (includeJPaths.length === 0 && includeJPathRegexps.length === 0) {
            return true;
        }
        if (includeJPaths.length > 0 && includeJPaths.includes(path))
            return true;
        return includeJPathRegexps.some((re) => re.test(path));
    }
    function isExcluded(path) {
        if (excludeJPaths.length === 0 && excludeJPathRegexps.length === 0) {
            return false;
        }
        if (excludeJPaths.length > 0 && excludeJPaths.includes(path))
            return true;
        return excludeJPathRegexps.some((re) => re.test(path));
    }
    function traverse(value, prefix = '', depth = 0) {
        // Stop if depth exceeds maximum
        if (depth > maxDepth) {
            return [];
        }
        const modifier = modifiersMap.get(prefix);
        if (modifier) {
            value = modifier(value);
        }
        let result = [];
        if (isAnyArray(value)) {
            const limitedItems = value.slice(0, maxArrayElements);
            for (const [idx, item] of limitedItems.entries()) {
                const newPrefix = prefix ? `${prefix}.${idx}` : `${idx}`;
                result = result.concat(traverse(item, newPrefix, depth + 1));
            }
        }
        else if (typeof value === 'object' && value !== null) {
            for (const key of Object.keys(value)) {
                const child = value[key];
                const newPrefix = prefix ? `${prefix}.${key}` : key;
                result = result.concat(traverse(child, newPrefix, depth + 1));
            }
        }
        else if ((typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean') &&
            matchesInclude(prefix) &&
            !isExcluded(prefix)) {
            result.push({ jpath: prefix, value });
        }
        return result;
    }
    return traverse(obj);
}
//# sourceMappingURL=getJPaths.js.map